import type { FigmaRestApi } from "@zeytal/types";

import { addQueryParams, getFigmaEndpoint } from "../utils/index.ts";

export const getFigmaFileEndpoint = async (
  figmaApiKey: string,
  figmaFileId: string,
  queryParams = "",
) => {
  const endpoint = `https://api.figma.com/v1/files/${figmaFileId}`;
  return getFigmaEndpoint<FigmaRestApi.GetFileResponse>(
    figmaApiKey,
    addQueryParams(endpoint, queryParams),
  );
};
